export default __webpack_public_path__ + "static/media/sticker-W.7427c89c.png";